import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/BlogBariyerli.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/BlogBondex.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/BlogCiftBariyerli.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/BlogList.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/Cart.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexAnkara.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexAntalya.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexBursa.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexIstanbul.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexIzmir.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexKayseri.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexKocaeli.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexKonya.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexMugla.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexSakarya.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexSilivri.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexTekirdag.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/CityBondexYalova.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/Contact.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/License.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetail"] */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/ProductDetail.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/views/Products.tsx");
